import React from "react";
import FormattedMessage from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { Body, H3 } from "@irati/ui/src/Typography";
import { EmptyRows } from "./styled";
var EmptyCompanyNews = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(EmptyRows, null,
        React.createElement(H3, { marginBottom: 1 },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.empty.title" })),
        React.createElement(Body, { marginBottom: 4 },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.empty.message" })),
        React.createElement(Button, { primary: true, onClick: onClick },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.empty.button" }))));
};
export default EmptyCompanyNews;
